"use client";

import React from "react";

import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { COLOR_BLACK, COLOR_GREYSCALE_BLACK_15 } from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { PROGRESS_BAR_CLASSES } from "./constants";

interface StylesProps {
  normalizedCurrentProgress: number;
}
export const ProgressBarContainer = styled(
  ({ normalizedCurrentProgress, ...props }: StylesProps & BoxProps) => (
    <Box {...props} />
  ),
)(({ theme, normalizedCurrentProgress }) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP, BREAKPOINT_WIDE_DESKTOP } =
    getFormatMedia(theme);
  return {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    margin: theme.spacing(1, 0),
    width: "100%",
    [BREAKPOINT_TABLET]: {
      width: 340,
    },
    [BREAKPOINT_DESKTOP]: {
      width: 504,
    },
    [BREAKPOINT_WIDE_DESKTOP]: {
      width: 504,
    },
    [`& .${PROGRESS_BAR_CLASSES.bar}`]: {
      position: "relative",
      height: 4,
      backgroundColor: COLOR_GREYSCALE_BLACK_15,
      width: "100%",
      aspectRatio: "20 / 1",
    },
    [`& .${PROGRESS_BAR_CLASSES.indicator}`]: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      backgroundColor: COLOR_BLACK,
      transformOrigin: "left",
      transform: `scaleX(${normalizedCurrentProgress})`,
      transition: `transform 0.3s ease`,
      width: "100%",
    },
    [`& .${PROGRESS_BAR_CLASSES.centered}`]: {
      textAlign: "center",
      minHeight: "1.5rem",
    },
  };
});
